import ApplicationVariable from "../models/applications/ApplicationVariable";

export const getFieldVariationPrefix = (fieldTitle: string): string =>
    `Form_Field_${fieldTitle}_`;

export const getFieldVariationConstantName = (
    fieldTitle: string,
    variationName: string
): string => `${getFieldVariationPrefix(fieldTitle)}${variationName}`;

export const getFieldVariations = (
    variables: ApplicationVariable[],
    fieldTitle: string
): ApplicationVariable[] => {
    const prefix = getFieldVariationPrefix(fieldTitle);
    return (variables || []).filter(variable => variable.name.startsWith(prefix));
};

export const getFieldVariationDisplayName = (
    constantName: string,
    fieldTitle: string
): string => {
    const prefix = getFieldVariationPrefix(fieldTitle);
    return constantName.startsWith(prefix)
        ? constantName.substring(prefix.length)
        : constantName;
};
